import styled from 'styled-components';

export const Container = styled.div`
    background-color: ${p => p.theme.c.boost};
    margin: -24px;
    padding: 24px;
    border-radius: 8px;
`;

export const Row = styled.div`
    display: flex;
`;